<script setup lang="ts">
import {initAos} from '~/utils/initAos';

onMounted(() => {
    initAos({
        once: true
    });
});
</script>

<template>
    <NuxtLayout>
        <NuxtPage />
    </NuxtLayout>
</template>

<style lang="scss">
@import "assets/styles/scss/index";
</style>
